import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { applyContainerQuery } from 'react-container-query';
import { Modal } from '@resy/ui-kitchen';
import ModalNav from '../../ModalNav/ModalNav';
import UPDATE_PHONE_STEPS from './updatePhoneSteps';
import UpdatePhone from './UpdatePhone';
import VerifyPhone from './VerifyPhone';
import UpdateSuccess from './UpdateSuccess';
import './UpdatePhoneView.scss';
import containerQueryMap from '../../../../../widget/app/modules/maps/containerQueryMap';
import { handleNavigate } from '../../../utils/locationUtils';
import RouterNavigationContext from '../../../../../widget/app/modules/contexts/RouterNavigate';

const UpdatePhoneContainer = (props) => {
  const {
    containerQuery, Analytics, context, closeModal, successCallback, flushRoute,
  } = props;
  const [currentStep, setCurrentStep] = useState(UPDATE_PHONE_STEPS.UPDATE_PHONE);
  const [newPhone, setNewPhone] = useState();
  const navigate = useContext(RouterNavigationContext);

  const handleBackClick = () => {
    setCurrentStep(UPDATE_PHONE_STEPS.UPDATE_PHONE);
  };

  const smsTriggered = (phoneNumber) => {
    setNewPhone(phoneNumber);
    setCurrentStep(UPDATE_PHONE_STEPS.VERIFY_PHONE);
  };

  const close = () => {
    if (context === 'widget') {
      handleNavigate('account/profile', navigate, flushRoute);
    } else {
      closeModal();
    }
  };

  const verificationComplete = () => {
    setCurrentStep(UPDATE_PHONE_STEPS.UPDATE_SUCCESS);

    setTimeout(() => {
      close();
    }, [3000]);

    if (successCallback) {
      successCallback(newPhone);
    }
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case UPDATE_PHONE_STEPS.UPDATE_PHONE:
        return <UpdatePhone smsTriggered={smsTriggered} />;
      case UPDATE_PHONE_STEPS.VERIFY_PHONE:
        return <VerifyPhone verificationComplete={verificationComplete} phoneNumber={newPhone} Analytics={Analytics} />;
      case UPDATE_PHONE_STEPS.UPDATE_SUCCESS:
        return <UpdateSuccess />;
      default:
        return <></>;
    }
  };

  return (
    <div className="UpdatePhoneContainer">
      <ModalNav
        close={close}
        containerQuery={containerQuery}
        onBackClick={handleBackClick}
        showBack={currentStep === UPDATE_PHONE_STEPS.VERIFY_PHONE}
      />
      <div className="UpdatePhoneView">
        {renderCurrentStep()}
      </div>
    </div>

  );
};

export const UpdatePhoneModal = ({ closeModal, ...props }) => (
  <Modal
    isOpen
    onRequestClose={closeModal}
    shouldCloseOnEsc
    shouldCloseOnOverlayClick={false}
  >
    <UpdatePhoneContainer closeModal={closeModal} {...props} />
  </Modal>
);

UpdatePhoneModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

UpdatePhoneContainer.displayName = 'UpdatePhoneContainer';

UpdatePhoneContainer.propTypes = {
  containerQuery: PropTypes.func,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
    page: PropTypes.func,
  }).isRequired,
  context: PropTypes.string.isRequired,
  flushRoute: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
  successCallback: PropTypes.func.isRequired,
};

UpdatePhoneContainer.defaultProps = {
  flushRoute: () => { },
};

UpdatePhoneContainer.defaultProps = {
  containerQuery: undefined,
};

export { UpdatePhoneContainer as ComponentUnderTest };

export default applyContainerQuery(UpdatePhoneContainer, containerQueryMap);
